import React from 'react'

const Loader = () => {
  return (
    <div className="preloader">
        <div className="preloader-inner">
            <div className="preloader-icon">
                <span></span>
                <span></span>
            </div>
        </div>
    </div>
  )
}

export default Loader
